import Vue from "vue";
const api_path = "/permissoes_locacao";

export async function listar() {
  const response = await Vue.prototype.$http.get(`${api_path}`);

  return response.data;
}
